import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  APP_ACTIONS,
  APP_VIEW,
} from "../../constants/constant";
import {
  fetchMachines,
  createMachine as createMachineAction,
  updateMachine as updateMachineAction,
  deleteMachine as deleteMachineAction,
} from "../../store/slices/dataManagement";
import { checkErrorMsg } from "../../utils/utils";
import ModalMessageFunction from "../../common/modal-message-function";
import ToastMessageFunction from "../../common/toast-message-function";
import { useTranslation } from "../../common/translation-context";
import DMGrid from "../../common/data-grid/dmGrid";

const Machine = () => {
  const { translate: t } = useTranslation();
  const dispatch = useDispatch();
  const { machines, loading, actionLoading, error } = useSelector((state) => state.machines);
  const [actionPerformed, setActionPerformed] = useState(false);
  const [requestType, setRequestType] = useState("");
  const [machineId, setMachineId] = useState();

  const processAction = (action, requestType) => {
    setActionPerformed(action);
    setRequestType(requestType);
  };

  const modalManager = ModalMessageFunction(processAction);
  const toastManager = ToastMessageFunction();
  const showToast = useCallback(
    (message, severity) => {
      toastManager.getToast(message, severity);
    },
    [toastManager]
  );

  const getModalAction = (requestType, requestStatus) => {
    modalManager.getModal(requestType, requestStatus);
  };

  const saveNewMachine = async (values) => {
    try {
      await dispatch(createMachineAction(values)).unwrap();
      showToast(t("addMachineToast"), "success");
      dispatch(fetchMachines());
    } catch (error) {
      if (checkErrorMsg(error)) showToast(checkErrorMsg(error), "error");
      else showToast(t("failAddMachine"), "error");
      dispatch(fetchMachines());
    }
  };

  const editMachine = async (values) => {
    try {
      await dispatch(updateMachineAction(values)).unwrap();
      showToast(t("updateMachineToast"), "success");
      dispatch(fetchMachines());
    } catch (error) {
      if (checkErrorMsg(error)) showToast(checkErrorMsg(error), "error");
      else showToast(t("failUpdateMachine"), "error");
    }
  };

  const deleteMachineHandler = async (machineId) => {
    try {
      await dispatch(deleteMachineAction(machineId)).unwrap();
      showToast(t("deleteMachineSuccess"), "success");
      dispatch(fetchMachines());
    } catch (error) {
      if (checkErrorMsg(error)) showToast(checkErrorMsg(error), "error");
      else showToast(t("failDeleteMachine"), "error");
    }
  };

  useEffect(() => {
    if (actionPerformed && requestType === "deleteMachine") {
      deleteMachineHandler(machineId);
    }
    setActionPerformed(false);
    setRequestType("");
  }, [actionPerformed, machineId]);

  const deleteMachine = (machineId) => {
    setMachineId(machineId);
    getModalAction(APP_ACTIONS.DELETEMACHINE, "deleteMachine");
  };

  useEffect(() => {
    dispatch(fetchMachines());
  }, [dispatch]);

  useEffect(() => {
    if (error) {
      showToast(error, "error");
    }
  }, [error]);

  return (
    <>
      {modalManager.modal}
      {toastManager.toast}

      <DMGrid
        id="table"
        view={APP_VIEW.DM}
        dmView="machines"
        isLoaderVisible={loading || actionLoading}
        row={machines}
        header="machines"
        count={machines?.length}
        buttonText="addMachine"
        create={saveNewMachine}
        edit={editMachine}
        delete={deleteMachine}
      />
    </>
  );
};

export default Machine;
